module.exports = __webpack_public_path__ + "media/images/emblems/Corcelles-BE-coat-of-arms-3068cc80e9ad7bf5b98ac98b2bcbba98.svg";